import "./Summary.scss";
import Typography from "../../../../components/Typography/Typography";
import { IconButton } from "@mui/material";

import linkSvg from "../../../../assets/Link.svg";

const Summary = ({ summarydata }: any) => {
  const { final_score, overall_summary, data } = summarydata;
  return (
    <div className="rfx_summary_wrapper">
      <div className="summary-content">
        <div className="content-container">
          {final_score && (
            <Typography
              fontSize="12px"
              fontWeight={600}
              color="#000000cc"
              letterSpacing="0px"
              lineHeight="20px"
            >
              Final Score: {final_score}
            </Typography>
          )}
          <Typography
            fontSize="12px"
            fontWeight={500}
            color="#000000cc"
            letterSpacing="0px"
            lineHeight="20px"
          >
            {overall_summary}
          </Typography>
          <br />

          {data?.map((paramaterData: any, idx: number) => (
            <div className="summary_points_container">
              <div>
                <strong>{`${idx + 1}. ${paramaterData?.text} (${
                  paramaterData?.score
                }): `}</strong>
                {paramaterData.summary}
                <IconButton
                  onClick={() => {}}
                  style={{
                    backgroundColor: "#3474E01A",
                    marginLeft: "8px",
                  }}
                >
                  <img src={linkSvg} alt="" />
                </IconButton>
              </div>
              <br />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Summary;
